import React, { useEffect, useRef, useState } from 'react';
import lottie, { AnimationEventName, AnimationItem } from 'lottie-web';
import Spinner, { SpinnerColor } from '../Spinner';

interface IProps {
  lottieAsset?: any;
  isLoop: boolean;
  isAutoplay: boolean;
  className: string;
  lottiePath?: string;
  eventListeners?: { event: string; callback: () => void }[];
  shouldUseLoader?: boolean;
}

const Lottie = ({
  lottieAsset,
  isLoop,
  isAutoplay,
  className,
  eventListeners,
  lottiePath,
  shouldUseLoader,
}: IProps) => {
  const container = useRef<HTMLDivElement | null>(null);
  const lottieInstance = useRef<AnimationItem | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (container.current) {
      // Initialize the Lottie instance
      lottieInstance.current = lottie.loadAnimation({
        container: container.current,
        loop: isLoop,
        autoplay: isAutoplay,
        animationData: lottieAsset || undefined,
        path: lottiePath || undefined,
        name: lottieAsset ? lottieAsset.nm : 'path-name',
      });

      // Event listener for when the animation is fully loaded
      lottieInstance.current.addEventListener('data_ready', () => {
        setIsLoading(false);
      });

      // Add custom event listeners if provided
      if (eventListeners) {
        eventListeners.forEach((listener) => {
          lottieInstance.current?.addEventListener(listener.event as AnimationEventName, listener.callback);
        });
      }
    }

    // Cleanup function to destroy the Lottie instance
    return () => {
      if (lottieInstance.current) {
        lottieInstance.current.destroy();
        lottieInstance.current = null;
      }
    };
  }, [lottieAsset, lottiePath]);

  return (
    <div className={className}>
      {isLoading && shouldUseLoader ? (
        <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />
      ) : (
        <div ref={container} />
      )}
    </div>
  );
};

export default Lottie;
